import { uri } from '../../api-endpoint';
import {
  IModelAPIValidationError,
  IModelFromAPISuccessResponse
} from '../../type-conversion/model/from-api-repsonse';
import { ModelAPIRequestBody } from '../../type-conversion/model/to-api-request-body';
import { createTemplateFn } from '../common';

export const createModel = (token: string) => (companyId: number) =>
  createTemplateFn(
    token,
    uri.modelListOfCompany(companyId),
    ModelAPIRequestBody,
    IModelFromAPISuccessResponse,
    IModelAPIValidationError
  );
